import { useReducer, useEffect } from "react";
import fleetSearchReducer, { initialState } from "./reducer";
import { fetchFleetSearchDetails } from "./api";
import ACTIONS from "./actions";

async function getFleetSearchDetails(dispatch) {
  dispatch({ type: ACTIONS.FETCH_FLEET_SEARCH_INIT });
  try {
    const fleetSearchDetails = await fetchFleetSearchDetails();
    if (fleetSearchDetails) {
      dispatch({ type: ACTIONS.FETCH_FLEET_SEARCH_SUCCESS, payload: fleetSearchDetails?.data });
    } else {
      dispatch({ type: ACTIONS.FETCH_FLEET_SEARCH_FAILURE });
    }
  } catch (error) {
    dispatch({ type: ACTIONS.FETCH_FLEET_SEARCH_FAILURE });
  }
}

function useFleetSearchReducer() {
  const [state, dispatch] = useReducer(fleetSearchReducer, initialState);

  useEffect(() => {
    getFleetSearchDetails(dispatch);
  }, []);

  // return only the status (step chart) slice to preserve previous hook API
  return {
    state,
  };
}

export default useFleetSearchReducer;
